import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';

const DownloadRequestEditReasonContent = ({ reason }) => {
  if (_.isArray(reason)) {
    return reason.map((r) => (
      <DownloadRequestEditReasonContent key={reason.id || reason.question} reason={r} />
    ));
  }

  const getFilteredNodes = (id) => {
    if (!reason.nodes) return [];

    const parts = id.split('_');
    const index = parseInt(parts[parts.length - 1]);

    if (reason.nodes[index] && Array.isArray(reason.nodes[index])) {
      const result = [];
      reason.nodes[index].forEach(item => {
        if (item.question || (item.answers && item.answers.length > 0)) {
          result.push(item);
        } else if (item.nodes && item.nodes.length > 0) {
          item.nodes.forEach(nestedGroup => {
            if (Array.isArray(nestedGroup)) {
              nestedGroup.forEach(nestedItem => {
                if (nestedItem.question || (nestedItem.answers && nestedItem.answers.length > 0)) {
                  result.push(nestedItem);
                }
              });
            }
          });
        }
      });
      return result;
    }

    return [];
  };

  return (
    <div className="download-details-reason-question">
      {reason.question && <p>{reason.question}:</p>}
      {reason.answers && reason.answers.length > 0 && (
        reason.answers.map((a) => (
          <div key={a.id} className="download-details-reason-question-answer">
            <span>
              {a.label && `${a.label}: `}
              {a.value}
            </span>
            {a.id && (
              <DownloadRequestEditReasonContent
                reason={getFilteredNodes(a.id)}
              />
            )}
          </div>
        ))
      )}
    </div>
  );
};

DownloadRequestEditReasonContent.propTypes = {
  reason: PropTypes.any.isRequired,
};

export default DownloadRequestEditReasonContent;
